import AutocompleteSelect from '@/gf/components/AutocompleteSelect'

const options = [
  { label: 'Air Fittings, Hoses and Valves', value: '1' },
  { label: 'Batteries and Components', value: '2' },
  { label: 'Body Components', value: '3' },
  { label: 'Boom Components', value: '4' },
  { label: 'Brakes and Brake Parts', value: '5' },
  { label: 'Brushes and Pads', value: '6' },
  { label: 'Electrical Components', value: '7' },
  { label: 'Engine Parts', value: '8' },
  { label: 'Forklift Parts', value: '9' },
  { label: 'Hardware and Fasteners', value: '10' },
  { label: 'Hydraulics', value: '11' },
  { label: 'Platform Components', value: '12' },
  { label: 'Steering Components', value: '13' },
  { label: 'Tanks', value: '14' },
  { label: 'Tires', value: '15' },
  { label: 'Tracks and Undercarriage', value: '16' },
  { label: 'Transmission Drivetrain and Axles', value: '17' },
  { label: 'Turntable Components', value: '18' },
  { label: 'Wear Parts', value: '19' },
  { label: 'accessories, bulbs', value: '20' },
  { label: 'accessories, cables', value: '21' },
  { label: 'accessories, oil and lubricants', value: '22' },
  { label: 'Tools', value: '23' },
]

const ClassificationSelect = ({
  value,
  onChange,
}: {
  value: number | null
  onChange: (string: string | null) => void
}) => (
  <AutocompleteSelect
    label=""
    name="storeSelection"
    className="w-full text-sm mb-1"
    value={value}
    options={options}
    onChange={onChange}
    reactSelectOptions={{
      isSearchable: true,
      isMulti: false,
      placeholder: 'search...',
    }}
  />
)

export default ClassificationSelect
